<template>
  <div>
    <div style="font-size: 36px; font-weight: 700; margin-top: 80px; margin-bottom: 80px; text-align: center">Not yet
      open！</div>
    <poster-module :type="1"></poster-module>
    <!-- <column-gray-grid :list="data.menus"></column-gray-grid>
    <q-a></q-a>
    <poster-module :type="1"></poster-module> -->
  </div>
</template>

<script>
import PosterModule from '../column/components/PosterModule';

export default {
  components: {
    PosterModule
  },
  data() {
    return {
      data: []
    }
  }
}
</script>